var _desc, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsoleKingsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 166",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Console Kings logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Red controller crown surrounding a cat-shaped area of negative space.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff334f",
    d: "     M128 0     C174 0 214 1 231 16     C244 29 251 63 256 94     L256 128     C255 147 246 160 231 165     C217 169 211 158 206 147     L193 116     C191 111 187 109 180 109     L221 54     L178 63     L192 73     L151 84     L128 23     L105 84     L64 73     L78 63     L35 54     L76 109     C69 109 65 112 63 118     L51 149     C47 161 42 168 29 165     C10 162 1 149 0 130     L0 94     C5 63 12 29 25 16     C42 1 82 0 128 0     Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff334f",
    d: "M106 110H150L128 137Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleKingsLogo);
export default __webpack_public_path__ + "static/media/console-kings-logo.d3fcefe7a08b30a852a2a01207b1fd16.svg";
export { ForwardRef as ReactComponent };